<div (animationend)="resetFadeIn($event)" [class.fade-in]="fadeIn()">
	<router-outlet #outlet="outlet" (activate)="updateAnimationState(outlet)"></router-outlet>
</div>
